import type { PointOfInterestImage } from 'landings/Home/Home.type'
import Image, { type ImageLoader, type ImageProps } from 'next/image'
import { cx } from 'utils/cx'
import styles from './BannerImage.module.scss'

interface BannerImageProps extends Omit<ImageProps, 'alt' | 'src'> {
	readonly image: PointOfInterestImage
	readonly imageLoader?: ImageLoader
	readonly sizes?: string
	readonly className?: string
	readonly priority?: boolean
}

export function BannerImage({
	image,
	sizes,
	imageLoader,
	className,
	priority = false,
}: BannerImageProps) {
	return (
		<Image
			className={cx(styles.image, className)}
			alt={image.description ?? ''}
			priority={priority}
			fetchPriority={priority ? 'high' : 'low'}
			src={image.url}
			style={{
				objectPosition: `${image.pointOfInterest.percentageX}% ${image.pointOfInterest.percentageY}%`,
			}}
			loader={imageLoader ?? undefined}
			sizes={sizes ?? '100vw'}
			draggable={false}
			fill
		/>
	)
}
